export const COLLAPSE_ELEM_BEFORE: unique symbol = Symbol('collapse-elem-before');
export type COLLAPSE_ELEM_BEFORE_TYPE = typeof COLLAPSE_ELEM_BEFORE;
